"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultId = exports.defaultIdMaker = void 0;
var tslib_1 = require("tslib");
var v4_1 = tslib_1.__importDefault(require("uuid/v4"));
var defaultIdMaker = function () { return (0, v4_1.default)(); };
exports.defaultIdMaker = defaultIdMaker;
exports.defaultId = (0, v4_1.default)();
